export default __webpack_public_path__ + "static/media/success_fingerprint.101d8d92.png";